module.exports = __webpack_public_path__ + "static/media/ucla-samueli-logo.fda5120b.svg";